import React, { useEffect, useState } from 'react'
/* import { makeStyles } from '@material-ui/core/styles' */
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import CloseIcon from '@material-ui/icons/Close'
import Title from '../Frame/Title'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { Grid, TableContainer, TablePagination } from '@material-ui/core'
import { format } from 'date-fns'

function refreshPage() {
  window.location.reload(false)
}
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export default function LastQuestions() {
  const db = firebase.firestore()
  const [rows, setRows] = useState([])
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  useEffect(() => {
    let flag = false
    try {
      setRows(JSON.parse(localStorage['questions']))
    } catch {
      flag = true
    }

    if (flag === true) {
      console.log('İstek atıldı')
      let rowsineffect = []
      db.collection('questions')
        .orderBy('date', 'desc')
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            let datas = doc.data()
            rowsineffect = [
              ...rowsineffect,
              {
                date: format(
                  new Date(datas.date['seconds'] * 1000),
                  'dd/MM/yy HH:mm'
                ),
                question: datas.question,
                answers: datas.answers,
                right_answer: datas.right_answer,
                level: datas.level,
              },
            ]
            setRows(rowsineffect)
            localStorage.setItem('questions', JSON.stringify(rowsineffect))
          })
        })
        .catch(function (error) {
          console.log('Error getting documents: ', error)
        })
    } else {
      db.collection('questions')
        .orderBy('date', 'desc')
        .limit(1)
        .get()
        .then((querySnapshot) => {
          console.log(JSON.parse(localStorage['questions'])[0])
          if (
            querySnapshot.docs[0].data().question ===
            JSON.parse(localStorage['questions'])[0].question
          ) {
            console.log('İstek atılmadı')
            setRows(JSON.parse(localStorage['questions']))
          } else {
            console.log('İstek atıldı')
            let rowsineffect = []
            db.collection('questions')
              .orderBy('date', 'desc')
              .get()
              .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                  let datas = doc.data()
                  rowsineffect = [
                    ...rowsineffect,
                    {
                      date: format(
                        new Date(datas.date['seconds'] * 1000),
                        'dd/MM/yy HH:mm'
                      ),
                      question: datas.question,
                      answers: datas.answers,
                      right_answer: datas.right_answer,
                      level: datas.level,
                    },
                  ]
                  setRows(rowsineffect)
                  localStorage.setItem(
                    'questions',
                    JSON.stringify(rowsineffect)
                  )
                })
              })
              .catch(function (error) {
                console.log('Error getting documents: ', error)
              })
          }
        })
    }
  }, [db])
  return (
    <React.Fragment>
      <Title>Son Sorular</Title>
      <TableContainer>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>Tarih</TableCell>
              <TableCell>Soru</TableCell>
              <TableCell>Cevaplar</TableCell>
              <TableCell>Zorluk Seviyesi</TableCell>
              <TableCell align='right'>Kontroller</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>{row.date}</TableCell>
                    <TableCell>{row.question}</TableCell>
                    <TableCell>
                      <Grid container direction='column'>
                        {row.answers.map((answer, index) => {
                          if (answer === row.answers[row.right_answer]) {
                            return (
                              <Grid
                                item
                                style={{ fontWeight: 'bold' }}
                                key={index}
                              >
                                {answer}
                              </Grid>
                            )
                          } else {
                            return (
                              <Grid item key={index}>
                                {answer}
                              </Grid>
                            )
                          }
                        })}
                      </Grid>
                    </TableCell>
                    <TableCell>{row.level}</TableCell>
                    <TableCell align='right'>
                      <CloseIcon
                        style={{}}
                        onClick={async () => {
                          let jobskill_query = db
                            .collection('questions')
                            .where('question', '==', row.question)
                          jobskill_query.get().then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                              doc.ref.delete()
                            })
                          })
                          let delRecord = JSON.parse(
                            localStorage.getItem('questions')
                          )
                          delRecord.shift()

                          localStorage.setItem(
                            'questions',
                            JSON.stringify(delRecord)
                          )

                          await sleep(1000)
                          refreshPage()
                        }}
                      ></CloseIcon>
                    </TableCell>
                  </TableRow>
                )
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component='div'
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </React.Fragment>
  )
}
